import React from 'react';
import PropTypes from 'prop-types';
import Logo from 'components/logo';
import Link from 'components/link';
import linkThemes from 'components/link/link-themes';
import linkSizes from 'components/link/link-sizes';

const Footer = ({ logo, links }) => {
  return (
    <div className="footer">
      <div className="footer__container">
        <div className="footer__content">
          {logo && logo.url && (
            <Logo
              {...logo}
              className="footer__logo"
              imageClass="image_size_footer-logo"
            />
          )}
          {links && links.length > 0 ? (
            <ul className="footer__list">
              {links.map((item, i) => (
                <li key={i} className="footer__item">
                  <Link
                    {...item}
                    theme={linkThemes.light}
                    size={linkSizes.small}
                  />
                </li>
              ))}
            </ul>
          ) : null}
        </div>
      </div>
    </div>
  );
};

Footer.propTypes = {
  logo: PropTypes.exact(Logo.propTypes),
  links: PropTypes.arrayOf(PropTypes.shape(Link.propTypes)),
};

export default Footer;
